// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/1.2.0/css/" + chunkId + "." + {"pages/MyReviewEdit":"ae06aae5","src_components_CustomDialog_DialogFooter_index_tsx-src_components_MediaExpandedView_index_tsx-6a3f58":"26253dcb","pages/MyReviewPage":"43c7d67a","pages/PostReview":"d1e08ccf","pages/ProviderReview":"db1de0cf"}[chunkId] + ".chunk.css";
};